<template>
  <vue-drawer-layout
      ref="drawer"
      :enable="false"
      :drawer-width="300"
      @mask-click="closeDrawer">
    <div slot="drawer">
      <NavigationDrawer :close="closeDrawer" class="navigation-drawer"/>
    </div>
    <div slot="content" class="root-pane">
      <NavigationBar :toggle="openDrawer" class="nav"/>
      <div class="test" v-if="isMobile">
        <p class="p-tag" v-if="!isSelectRequestPage && $store.getters.getSelectedWallet && userChecker" :style="buttonStyle">Bal: K{{ balance }}</p>
      </div>
      <div class="navigation-route-view">
        <router-view/>
      </div>
    </div>
  </vue-drawer-layout>
</template>

<script>
import NavigationBar from "./navigation/NavigationBar.vue";
import NavigationDrawer from "./navigation/NavigationDrawer.vue";
import axios from "axios";

export default {
  name: "Layout",
  components: {NavigationDrawer, NavigationBar},
  data() {
    return {
      isMobile: false,
      balance: 0,
      userChecker: false,
    }
  },
  created() {
    this.checker();
    this.fetchBalance();
  },
  computed: {
    isSelectRequestPage() {
      return this.$route.name === 'SelectRequest';
    },
    curUser() {
      return this.$store.getters.getCurrentUser;
    },
    buttonStyle() {
      return {
        color: this.getGradientColor(this.balance),
        transition: "background 0.3s ease"
      };
    },
    currentSelectedWallet() {
      return this.$store.getters.getSelectedWallet;
    },
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfMobile);
  },
  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    async fetchBalance() {
      try {
        const selectedWallet = this.currentSelectedWallet;
        if (!selectedWallet) return;
        this.$utils.showLoading();
        const response = await axios.get(`${ticketApi2}transaction-handler/getWalletBalance/${selectedWallet}`);
        this.balance = response.data; // Adjust based on actual response structure
      } catch (error) {
        return errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    getGradientColor(balance) {
      if (balance >= 75000) {
        return 'green';
      } else if (balance >= 50000) {
        return 'orange';
      } else if (balance >= 20000) {
        return 'darkorange';
      } else {
        return 'red';
      }
    },
    checker() {
      this.userChecker = this.curUser.username === "Chris";
      // this.userChecker = this.curUser.username === "Test";
      console.log(this.userChecker);
    },
    openDrawer() {
      this.$refs.drawer.toggle();
    },
    closeDrawer() {
      this.$refs.drawer.toggle(false);
    }
  }
}
</script>


<style lang="scss" scoped>
.root-pane {
  //display: flex;
  //flex-direction: column;
  //justify-content: space-evenly;
}

.navigation-drawer {
  min-width: 285px;
  width: 100%;
  height: 100vh;
}

.navigation-route-view {
  transition: 0.5s ease;
}

.offline-banner {
  position: sticky;
  top: 0;
  left: 0;
  padding: 5px;
  display: block;
  text-align: center;
  width: 100%;
  background: rgb(220, 53, 69);
  color: white;
  right: 0;
}
.test {
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 20px;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
}

.button {
  background-color: white;
  color: dimgray;
  border-radius: 5px;
  font-size: 17px;
  font-weight: 600;
  padding: 8px 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: 1px solid black;
  box-shadow: 0 0 0 0 black;
}

.button:hover {
  transform: translateY(-4px) translateX(-2px);
  box-shadow: 2px 5px 0 0 black;
}

button:active {
  transform: translateY(2px) translateX(1px);
  box-shadow: 0 0 0 0 black;
}

.p-tag {
  margin-left: auto;
  font-weight: 600;
  font-size: 26px;
}
</style>
